import { combineReducers } from 'redux'
import ssoReducer from './sso/ssoReducer'
import brandsReducer from './brands/brandsReducer'
import calendarReducer from './calendar/calendarReducer'
import shipsReducer from './ships/shipsReducer'
import selectionsReducer from './selections/selectionsReducer'

const rootReducer = combineReducers({
  brands: brandsReducer,
  calendar: calendarReducer,
  ships: shipsReducer,
  selections: selectionsReducer,
  sso: ssoReducer,
})

export default rootReducer
